<template>
  <div class="login-container">
    <div class="login-main-wrapper">
      <div class="login-main-title">{{ app_name }}</div>
      <div class="login-main-container">
        <div class="login-welcome">
          <img src="@/assets/login-img.png" class="login-welcome-pic">
        </div>
        <div class="login-form-wrap">
          <div class="form-title">
            <img src="@/assets/logo.png" alt="">
          </div>
          <el-form :model="loginForm" :rules="loginRules" class="login-form" label-positin="left" label-width="0px"
                   ref="loginRef">
            <el-form-item prop="username">
              <el-input :autofocus="true" auto-complete="off" placeholder="用户名" prefix-icon="el-icon-user"
                        type="text" v-model="loginForm.username"></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input @keyup.native.13="loginFormSubmit('loginRef')" auto-complete="off" placeholder="密码"
                        prefix-icon="el-icon-lock" type="password" v-model="loginForm.password"></el-input>
            </el-form-item>
            <el-form-item prop="remember" style="font-size: 14px;margin: 0 0 15px 0;">
              <el-checkbox v-model="loginForm.remember">记住我</el-checkbox>
              <a style="float: right;color: #0080FF ;" href="#">忘记密码</a>
            </el-form-item>
            <el-form-item class="submit-item">
              <el-button :loading="logining" @click.native.prevent="loginFormSubmit('loginRef')"
                         style="width: 100%;" type="primary">登录
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {login} from "@/api/auth"
import {APP_NAME} from "@/utils/config"

export default {
  name: "Login",
  data() {
    return {
      loginBg: require('@/assets/login-img.png'),
      app_name: APP_NAME,
      logining: false,
      loginForm: {
        username: '',
        password: '',
        remember: false,
      },
      loginRules: {
        username: [
          {required: true, message: '请输入用户名', trigger: 'blur'},
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'},
        ]
      },
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    loginFormSubmit(ref) {
      let that = this
      that.$refs[ref].validate((valid) => {
        if (!valid) {
          console.log("submit error")
          return false
        }
        that.logining = true
        login(that.loginForm.username, that.loginForm.password).then(res => {
          console.log(res);
          that.logining = false
          that.$store.dispatch('auth/login', {authorization: res.authorization, user: res.user})
          that.$router.push({path: '/index'})
        }).catch(err => {
          that.logining = false
          console.log(err)
        })
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.login-container {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  position: relative;

  .login-main-wrapper {
    width: 1200px;
    margin-bottom: 100px;

    .login-main-title {
      color: $--color-primary;
      font-size: 30px;
      font-weight: 500;
      text-align: left;
      line-height: 60px;
    }

    .login-main-container {
      width: 1200px;
      height: 455px;
      background-color: $--color-primary;
      margin: auto;
      display: flex;

      .login-welcome {
        height: 455px;
        width: 678px;
        display: flex;
        justify-content: center;
        align-items: center;

        .login-welcome-pic {
          height: 418px;
          width: 618px;
          object-fit: contain;
          user-select: none;
          --webkit-user-drag: none;
        }
      }

      .login-form-wrap {
        width: 410px;
        height: 400px;
        padding: 0 40px;
        background-color: white;
        border-radius: 12px;
        margin-top: -60px;
        box-shadow: 0 0 20px 4px rgba(0, 0, 0, .06);

        .form-title {
          padding: 50px 0 35px 0;
          text-align: center;

          img {
            user-select: none;
            --webkit-user-drag: none;
          }
        }
      }

      @media only screen and (max-width: 810px) {
        & {
          width: 100vw;
          min-height: 410px;
        }
        .login-welcome {
          width: calc(100% - 410px);
          transition: width .45s linear;
        }
      }
    }
  }
}
</style>
